import React, { Component } from 'react'
import InputNameUI from './InputNameUI.js'

class InputNameSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      clientFirstNameError: null,
      clientLastNameError: null
    }
  }

  render() {
    return (
      <InputNameUI
        type={this.props.type}
        firstName={this.props.firstName}
        lastName={this.props.lastName}
        onFirstNameChange={this.props.onFirstNameChange}
        onLastNameChange={this.props.onLastNameChange}
        label={this.props.label}
        messageList={this.props.messageList}
        labelKey={this.props.labelKey}
        required={this.props.required}
        firstNameError={this.state.clientFirstNameError || this.props.firstNameError}
        lastNameError={this.state.clientLastNameError || this.props.lastNameError}
        setFirstNameClientError={this.setFirstNameClientError}
        setLastNameClientError={this.setLastNameClientError}
        autoFocus={this.props.autoFocus}
      />
    )
  }

  setFirstNameClientError = (clientFirstNameError) => {
    this.setState({clientFirstNameError: clientFirstNameError})
  }

  setLastNameClientError = (clientLastNameError) => {
    this.setState({clientLastNameError: clientLastNameError})
  }

}

export default InputNameSF
